<!--
 * @Author: zxf
 * @Date: 2022-07-26 10:20:56
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:10:01
 * @Description: 维保计划建筑列表
-->
<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--detail"
  >
    <!-- <div
      v-if="operationShow"
      class="u-mg-b-10"
    >
      <k-button
          btn-text="导出"
:auth-type="false"
        v-if="operationShow"
        type="success"
        icon="kestrel-icon ki-plus"
        @click="handleDialog('add', {dlType: 'add'})"
      >
        新增
      </k-button>
    </div> -->

    <k-table-infinite
      v-loading="loading"
      :infinite-scroll-disabled="isDisabled"
      :infinite-scroll-immediate="false"
      height="550px"
      :table-column="tableColumn"
      :data="page.rows"
      @infiniteLoad="getDataNextPage"
    >
      <template
        #jzwmc="scope"
      >
        <el-link
          type="primary"
          @click="handleDialog('view', {dlType: 'view', id: scope.row.jzwId})"
        >
          {{ scope.row.jzwmc }}
        </el-link>
      </template>

      <el-table-column
        v-if="operationShow"
        prop="enabled"
        label="操作"
        width="120"
        align="center"
        fixed="right"
      >
        <template
          slot-scope="scope"
        >
          <k-button
            btn-text="编辑"
            :auth-type="true"
            type="primary"
            plain
            @click="handleDialog('edit', {dlType: 'edit', id: scope.row.jzwId})"
          />
          <k-button
            btn-text="删除"
            :auth-type="true"
            type="danger"
            @click="handleDel(scope.row, scope.$index)"
          />
        </template>
      </el-table-column>
    </k-table-infinite>

    <!-- 更新建筑信息 -->
    <wbjz-update-dialog
      v-if="showDialogName==='add' || showDialogName==='edit'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 查看建筑信息 -->
    <wbjz-view-dialog
      v-if="showDialogName==='view'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import WbjzUpdateDialog from './updateDialog.vue';
import WbjzViewDialog from './viewDialog.vue';
import { wbjzService } from './wbjz.service';
export default {
  name: 'WbjzList',
  components: {
    WbjzUpdateDialog,
    WbjzViewDialog
  },
  props: {
    paginationShow: {
      type: Boolean,
      default: true
    },
    operationShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      isMore: false, // 更多标志
      isDisabled: false, // 可不用标志
      loadedPageNo: 0, // 已加载页码

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null // 项目编码
      },
      /* 查询条件 end */

      /* 查询条件（页面绑定的查询条件） start */
      trueFilterParams: { },
      /* 查询条件 end */
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 50,
        pageNo: 0
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jzwmc', slotName: 'jzwmc', label: '建筑名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zdmj', label: '占地面积（m²）', align: 'left', minWidth: '100', type: 'text' },
        { key: 'jzmj', label: '建筑面积（m²）', align: 'left', minWidth: '100', type: 'text' },
        { key: 'lcs', label: '楼层数', align: 'left', minWidth: '80', type: 'text' },
        { key: 'jzgd', label: '建筑高度（m）', align: 'left', width: '100', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  methods: {
    getDataNextPage () {
      // if (this.loadedPageNo === this.page.pageNo + 1) {
      // } else if (this.loadedPageNo !== this.page.pageNo + 1 && this.page.pageNo < this.page.totalPages) {
      //   this.isMore = true;
      //   this.isDisabled = false;
      //   this.search(this.page.pageNo + 1);
      // } else {
      //   this.isMore = false;
      //   this.isDisabled = true;
      // }
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.page.rows = [];
      this.page.pageNo = 0;
      this.page.totalPages = 0;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      const _this = this;
      /* 处理分页参数 Start */
      _this.trueFilterParams.pageSize = _this.page.pageSize;
      _this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      _this.loading = true;

      wbjzService.query(_this.trueFilterParams)
        .then(rsp => {
          const rows = _this.page.rows;
          _this.page = rsp.data;
          _this.page.rows = rows.concat(rsp.data.rows);
          if (_this.page.rows.length < rsp.data.total && rsp.data.hasNext) {
            _this.search(rsp.data.pageNo + 1);
          }

          // 导出条件更新为查询使用的条件
          _this.exportFilterParams = JSON.parse(JSON.stringify(_this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此建筑信息：${_row.jzwmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wbjzService.delete(_row.jzwId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    this.filterParams.xmId = this.$route.params.xmId;
    this.refreshSearch();
  },
  activated () {
    this.filterParams.xmId = this.$route.params.xmId;

    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }

};
</script>
<style lang="scss">
.dev-c-tab--header_button{
  margin-bottom: 10px;
}

</style>
